import AuthService from "../../service";
const location = {
  getLocation(page,search,sort_branch,sort_date) {
    return AuthService.get(`/about/location?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&sort_branch=${sort_branch}` +
      `&search=${search}`
    );
  },
  showLocation(id) {
    return AuthService.get(`/about/location/${id}`);
  },
  createLocation(data) {
    return AuthService.post(`/about/location`,data);
  },
  updateLocation(id, data) {
    return AuthService.put(`/about/location/${id}`,data);
  },
  deleteLocation(id) {
    return AuthService.delete(`/about/location/${id}`);
  }
};
export default location;
